import { render } from "./AgreePopUp.vue?vue&type=template&id=ef06d124"
import script from "./AgreePopUp.vue?vue&type=script&lang=js"
export * from "./AgreePopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__